import { serializeQueryString } from './serializeQueryString';

export function getCurrentUrl ({url = null, params = null}, includeParams = false) {

    const currentUrl = typeof url == 'string' ? url : url?.join('/');

    if (currentUrl == null)
        return null;

    if (!includeParams || params == null)
        return currentUrl;

    const queryString = serializeQueryString(params);

    if (queryString == null)
        return currentUrl;

    return currentUrl + '?' + queryString;

}